import { useEffect, useState } from "react";
import axios from "axios";
import { Card, PageHero } from "../../../components";
import { useAuth } from "../../../context/AuthContext";
import ZmenaHeslaKarta from "./ZmenaHeslaKarta";
import EmailKarta from "./EmailKarta";
import { PROFILE_URL } from "../../../features/UrlHelper";

/**
 * Profil OBSLUHY (vodic, manazer, admin, superadmin).
 *
 * Vyzera rovnako ako zakaznicky (`ZakaznickyProfil`) -- to iste zahlavie a
 * ta ista mriezka kariet --, len bez salda a adries, ktore obsluha nema.
 * Meno a telefon tu su len na citanie: obsluhe ich spravuje admin v sprave
 * pouzivatelov, nie ona sama.
 *
 * Karty su tri, preto osobne udaje idu cez celu sirku a e-mail s heslom pod
 * nimi vedla seba -- inak by jedna z nich ostala v riadku sama.
 */
const ROLE_LABEL = {
  SUPERADMIN: "Superadmin",
  ADMIN: "Admin",
  MANAGER: "Manažér",
  DRIVER: "Vodič",
};

function ProfilObsluhy() {
  const { userRole } = useAuth();
  const [profil, setProfil] = useState(null);
  const [nacitava, setNacitava] = useState(true);

  useEffect(() => {
    axios
      .get(PROFILE_URL)
      .then(({ data }) => setProfil(data))
      .catch((err) => console.error("Failed to load profile:", err))
      .finally(() => setNacitava(false));
  }, []);

  const hero = (
    <PageHero
      eyebrow="Nastavenia účtu"
      title="Môj"
      zvyraznene="profil"
      lead="Osobné údaje, e-mail a prihlasovacie heslo."
    />
  );

  if (nacitava || !profil) {
    return (
      <div className="profile__section profile__section--zakaznik">
        {hero}
        <div className="profile__karty">
          {nacitava ? (
            <p>Načítavam...</p>
          ) : (
            <p className="profile__form-error">Údaje sa nepodarilo načítať.</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="profile__section profile__section--zakaznik">
      {hero}

      <div className="profile__karty">
        {/* ── Osobné údaje ── */}
        <Card className="profile__karta--siroka">
          <Card.Header>
            <Card.Title>Osobné údaje</Card.Title>
          </Card.Header>
          <Card.Body>
            <div className="profile__form">
              <div className="profile__form-row">
                <div className="profile__form-field">
                  <label className="profile__form-label" htmlFor="obs-meno">Meno</label>
                  <input id="obs-meno" className="profile__form-input" value={profil.firstname || ""} disabled />
                </div>
                <div className="profile__form-field">
                  <label className="profile__form-label" htmlFor="obs-priezvisko">Priezvisko</label>
                  <input id="obs-priezvisko" className="profile__form-input" value={profil.lastname || ""} disabled />
                </div>
              </div>
              <div className="profile__form-row">
                <div className="profile__form-field">
                  <label className="profile__form-label" htmlFor="obs-telefon">Telefón</label>
                  <input id="obs-telefon" className="profile__form-input" value={profil.phone || "—"} disabled />
                </div>
                <div className="profile__form-field">
                  <label className="profile__form-label" htmlFor="obs-rola">Rola</label>
                  <input
                    id="obs-rola"
                    className="profile__form-input"
                    value={ROLE_LABEL[userRole] || userRole || ""}
                    disabled
                  />
                </div>
              </div>
              <p className="profile__form-hint">
                Meno, telefón a rolu mení administrátor prevádzky v správe používateľov.
              </p>
            </div>
          </Card.Body>
        </Card>

        <EmailKarta
          email={profil.email || ""}
          onZmenene={(email) => setProfil((p) => ({ ...p, email }))}
        />

        <ZmenaHeslaKarta />
      </div>
    </div>
  );
}

export default ProfilObsluhy;
